module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_3016.bbe91a3f.png";